
import TableList from "@components/templates/tablelist";
import { 
    HttpGetSupplier,
    HttpStopSupplier,
    HttpAduitSupplier,
    HttpGetPaymentByOrgId,
} from "@/service/purchase/purchase";
import { mapState,mapGetters } from "vuex";
import comIndex from './update/index'
import comExcel from '@components/templates/excelalert'
export default {
    mixins: [TableList],
    components: {
        comIndex,
        comExcel
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                }
            },
            Searchs: {
                show: true,
                labelWidth: 120,
            },
            Plugins: {show: true},
            erpSkusList:[],
            paymentList: [],
            category:'',
        }
    },
    created () {
        this.getPaymentTerm();
    },
    methods: {
        ajaxRequest: HttpGetSupplier,
        // 全部按钮点击操作
        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning(this.$t('boss.purchase.select_data',{defaultValue:'请选择至少一条数据'}));
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'supplierUpdate',
                        params: { type: "add" },
                    });
                    break;
                case "edit":
                    var url=this.$router.resolve({
                        name: "supplierUpdate",
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "query":
                    this.operate = {
                        title:this.$t('boss.purchase.view',{defaultValue:'查看'}),
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeid:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "queryBlank":
                    var url=this.$router.resolve({
                        name: "supplierUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "disable":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('boss.purchase.deactivate',{defaultValue:'停用'}),
                        desc: this.$t('boss.purchase.sure_to_discontinue',{defaultValue:'确定停用？停用后供应商和供应商产品将自动失效！'}),
                        width: 460,
                        params:{ids:params},
                        ajaxRequest:HttpStopSupplier
                    };
                    break;
                case 'moreImport':
                    // 点击导入按钮
                    this.operate = {
                        show: true,
                        title: this.$t('boss.purchase.batch_import',{defaultValue:'批量导入'}),
                        width:460,
                        showFooter: false,
                        data: {},
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/Supplier/importExcel",
                        name: "excelFile",
                        component: "compUpload",
                        download:()=>{
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/Supplier/downItemExcel?contextId=1', {}, 'download')
                        }
                    }
                    break;
                case 'exportQuery':
                    let queryObj = {}
                    Object.keys(this.formData.search).map(item => {
                        queryObj[`search[${item}]`] = this.formData.search[item]    
                    })
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/Supplier/exportXlsx", {...queryObj,showmessage:'no'}, {
                        executor: 'request',
                        download: true,
                    }).then(res=>{
                        this.operate = {
                            title: this.$t('boss.purchase.export_query_conditions',{defaultValue:'查询条件导出'}),
                            show: true,
                            width: 560,
                            component: "comExcel",
                            showFooter: false
                        }
                    }).catch(err => {
                        // this.$VMessage.error(err.message);
                    })
                break;
                case "allsubmit":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        title: this.$t('boss.purchase. ',{defaultValue:'提交审核'}),
                        width: 460,
                        params:{id:params},
                        formdata:[
                            {
                                tag: "vTextarea",
                                key: "remark",
                                labelWidth: 'auto',
                                span: 24,
                                label: this.$t('boss.purchase.notes',{defaultValue:'备注'}),
                                required:false,
                            }
                        ],
                        ajaxRequest:HttpAduitSupplier
                    };
                    break;
                case "enable":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('boss.purchase.enabled',{defaultValue:'启用'}),
                        width: 460,
                        params:{id:params},
                        ajaxRequest:HttpAduitSupplier
                    };
                    break;
                
            }
        },
        // 操作下的列表展示内容
        getOperateNodeMap(row){
            const { id,status } = row
            return [{
                label:this.$t('boss.purchase.view',{defaultValue:'查看'}),
                show:true,
                params:id,
                operate:'query'
            },{
                label:this.$t('boss.purchase.edit',{defaultValue:'编辑'}),
                show:true,
                to: {
                    name: 'supplierUpdate',
                    params: { type: 'edit' },
                    query: { id },
                },
            },{
                label:this.$t('boss.purchase.examine',{defaultValue:'审核'}),
                show:status == 'CHECK',
                params:id,
                operate:'allsubmit'
            },{
                label:this.$t('boss.purchase.deactivate',{defaultValue:'停用'}),
                show:status == 'NORMAL',
                params:id,
                operate:'disable'
            },{
                label:this.$t('boss.purchase.enabled',{defaultValue:'启用'}),
                show:status == 'STOP',
                params:id,
                operate:'enable'
            }]
        },
        
        getPaymentTerm () {
            HttpGetPaymentByOrgId().then(res => {
                this.paymentList = res.data.map(item => {
                    return {
                        attach: { ...item },
                        value: item.id,
                        label: item.paymentName
                    }
                });
            }, err => {
                this.$VMessage.error(err.message);
            });
        },
    },
    computed: {
        ...mapGetters('diction',['getNewProductList','getAllCostGroupName','getAllCurrency','getNewWarehouseIdList']),
        TabsData(){
            return [
                {
                    name: this.$t('boss.purchase.all',{defaultValue:'全部'}),
                    key:'EQ_status',
                    val: null
                }, {
                    name: this.$t('boss.purchase.normal_cooperation',{defaultValue:'正常合作'}),
                    key:'EQ_status',
                    val: 'NORMAL'
                }, {
                    name: this.$t('boss.purchase.deactivate',{defaultValue:'停用'}),
                    key:'EQ_status',
                    val: 'STOP'
                }, {
                    name: this.$t('boss.purchase.pending_approval',{defaultValue:'待审核'}),
                    key:'EQ_status',
                    val: 'CHECK'
                }
            ]
        },
        // 左边的批量操作按钮
        ToolsData(){
            return [
                {
                    name: this.$t('boss.purchase.add',{defaultValue:'新增'}),
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: this.$t('boss.purchase.batch_import',{defaultValue:'批量导入'}),
                    theme: 'success',
                    operate: 'moreImport',
                    more: true
                },
                {
                    name: this.$t('boss.purchase.batch_deactivation',{defaultValue:'批量停用'}),
                    operate: "disable",
                    theme: "warning",
                    batch:true,
                    more: true
                },{
                    name: this.$t('boss.purchase.export_query_conditions',{defaultValue:'查询条件导出'}),
                    theme: 'primary',
                    operate: 'exportQuery',
                },
            ]
        },
        // 搜索下拉框展示内容
        SearchsData() {
            let widthStyle = 'width: 250px'
            return  [
                {
                    label: this.$t('boss.purchase.supplier_name',{defaultValue:'供应商名称'}),
                    tag: 'vInput',
                    key: 'CN_name',
                    show:true,
                },
                {
                    label: this.$t('boss.purchase.supplier_classification',{defaultValue:'供应商分类'}),
                    tag: 'vSelect',
                    key: 'IN_bizCategory',
                    show: true,
                    options: [
                        {value:"STATUS_JOINT_OPERATION",label:this.$t('boss.purchase.joint_operation',{defaultValue:'联合运营'})},
                        {value:"STATUS_SELF_OPERATION",label:this.$t('boss.purchase.autonomous_operation',{defaultValue:'自主运营'})},
                        {value:"STATUS_PLATFORM",label:this.$t('boss.purchase.platform',{defaultValue:'平台'})},
                    ],
                    props:{
                        filterable:true,
                        multiple: true
                    }
                },
                {
                    label: this.$t('boss.purchase.supplier_code',{defaultValue:'供应商编码'}),
                    tag: "vInput",
                    key: "EQ_code",
                    show: true
                },
                // {
                //     label: "供应商状态",
                //     tag: 'vSelect',
                //     key: 'EQ_status',
                //     show:true,
                //     options: [
                //         {value:'NORMAL',label:'正常合作'},
                //         {value:'STOP',label:'停用'},
                //     ],
                //     props:{
                //         filterable:true,
                //     }
                // },

                {
                    label: this.$t('boss.purchase.supplier_name_english',{defaultValue:'供应商名称(英文)'}),
                    tag: 'vInput',
                    key: 'EQ_nameEn',
                    style: widthStyle
                },
                {
                    label: this.$t('boss.purchase.supplier_address_chinese',{defaultValue:'供应商地址(中文)'}),
                    tag: 'vInput',
                    key: 'EQ_address',
                    style: widthStyle
                },
                {
                    label: this.$t('boss.purchase.supplier_address_english',{defaultValue:'供应商地址(英文)'}),
                    tag: 'vInput',
                    key: 'EQ_addressEn',
                    style: widthStyle
                },
                {
                    label: this.$t('boss.purchase.collaboration_mode',{defaultValue:'合作方式'}),
                    tag: 'vSelect',
                    key: 'IN_coMode',
                    options: [
                        // {value:"UNDEFINE",label:"无合作方式"},
                        {value:"FACTORY",label:this.$t('boss.purchase.factory',{defaultValue:'工厂'})},
                        {value:"TRADE",label:this.$t('boss.purchase.foreign_trade',{defaultValue:'外贸'})},
                        {value:"OTHER",label:this.$t('boss.purchase.other',{defaultValue:'其他'})},
                    ],
                    props:{
                        filterable:true,
                        multiple: true
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('boss.purchase.settlement_remarks',{defaultValue:'结算备注'}),
                    tag: 'vInput',
                    key: 'CN_paymentExplain',
                    style: widthStyle
                },
                {
                    label: this.$t('boss.purchase.settlement_remarks',{defaultValue:'账号'}),
                    tag: 'vInput',
                    key: 'CN_accountNo',
                    style: widthStyle
                },
                {
                    label: this.$t('boss.purchase.contacts',{defaultValue:'联系人'}),
                    tag: 'vInput',
                    key: 'CN_supplierContactsEntityList.contact',
                    style: widthStyle
                },
                {
                    label: this.$t('boss.purchase.contact_phone',{defaultValue:'联系人电话'}),
                    tag: 'vInput',
                    key: 'CN_supplierContactsEntityList.contactTel',
                    style: widthStyle
                },
                {
                    label: this.$t('boss.purchase.beneficiary_name',{defaultValue:'收款人姓名'}),
                    tag: 'vInput',
                    key: 'EQ_receiver',
                    style: widthStyle
                },
                {
                    label: "Payment Term",
                    tag: "vSelect",
                    key: "IN_paymentTermId",
                    options: this.paymentList,
                    props: {
                        filterable: true,
                        multiple: true
                    },
                    style: widthStyle
                },
                // {
                //     label: '账期',
                //     key: "GE_paymentDay",
                //     tag: "vInputNumber",
                //     props: {
                //         min: 0
                //     },
                //     combineKey: 'paymentDay',
                //     style: 'width: 115px;'
                // },
                // {
                //     label: '~',
                //     key: "LE_paymentDay",
				// 	tag: "vInputNumber",
                //     props: {
                //         min: 0
                //     },
                //     formItem:{
                //         style: "margin-left: -100px"
                //     },
                //     combineKey: 'paymentDay',
                //     style: 'width: 115px;'
                // },
                {
                    label: this.$t('boss.purchase.created_at',{defaultValue:'创建时间'}),
                    tag: 'vDatepicker',
                    key: 'BT_created',
                    // default:this.initData,
                    props:{
                        options:this.options,
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('boss.purchase.supplier_type',{defaultValue:'供应商类型'}),
                    key: "IN_supplierType",
                    tag: "vSelect",
                    required: false,
                    props: {
                        multiple: true
                    },
                    options: [
                        {
                            value: 0,
                            label: this.$t('boss.purchase.purchasing_suppliers',{defaultValue:'采购供应商'})
                        },
                        {
                            value: 1,
                            label: this.$t('boss.purchase.service_provider',{defaultValue:'服务供应商'})
                        }
                    ],
                    style: widthStyle
                }
            ]
        },
        // table的展示数据
        columns() {
            return  [{
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            },{
                title: this.$t('boss.purchase.operate',{defaultValue:'操作'}),
                width: 90,
                render:this.getOperateNodes
            },
            {
                title: this.$t('boss.purchase.supplier_code',{defaultValue:'供应商编码'}),
                key: "code",
                width: 100
            },
            {
                title: this.$t('boss.purchase.supplier_name',{defaultValue:'供应商名称'}),
                key:'name',
                // sortable: true,
                render:(h,{row})=>{
                    return (
                    <div>
                        <div>
                            <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.name}</a>
                            <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                        </div>
                        <div>
                            {row.nameEn}
                        </div>
                    </div>
                    )
                }
            },
            {
                title: this.$t('boss.purchase.supplier_address',{defaultValue:'供应商地址'}),
                key:'nameEn',
                render: (h, {row}) => {
                    return (
                        <div>
                            <div>{row.address}</div>
                            <div>{row.addressEn}</div>
                        </div>
                    )
                }
                // render:(h,{row})=>{
                //     return <div>
                //         <div>{row.currency}</div>
                //     </div>
                // }
            },
            
            {
                title: this.$t('boss.purchase.supplier_classification_a',{defaultValue:'供应商分类/合作方式/对接人'}),
                render:(h, { row })=>{
                    let kind = ''
                    switch(row.bizCategory){
                        case 'STATUS_JOINT_OPERATION': kind = this.$t('boss.purchase.joint_operation',{defaultValue:'联合运营'})
                        break;
                        case 'STATUS_SELF_OPERATION': kind = this.$t('boss.purchase.autonomous_operation',{defaultValue:'自主运营'});
                        break
                        case 'STATUS_PLATFORM': kind = this.$t('boss.purchase.platform',{defaultValue:'平台'});
                        break
                    }
                    let cooperate = ''
                    switch (row.coMode) {
                        // case 'UNDEFINE': return '无合作方式';
                        case 'FACTORY': cooperate = this.$t('boss.purchase.factory',{defaultValue:'工厂'});
                        break
                        case 'TRADE': cooperate = this.$t('boss.purchase.foreign_trade',{defaultValue:'外贸'});
                        break
                        case 'OTHER': cooperate = this.$t('boss.purchase.other',{defaultValue:'其他'});
                        break
                    }
                    return (
                        <div>
                            <div>{kind}</div>
                            <div>{cooperate}</div>
                            <div>{row.broker}</div>
                        </div>
                    )
                }
            },
            {
                title: this.$t('boss.purchase.payment_information',{defaultValue:'收款信息'}),
                render:(h, { row })=>{
                    let paymentItem = this.paymentList.filter(item => {
                        return item.value == row.paymentTermId;
                    })[0];
                    let paymentName = paymentItem ? paymentItem.label : "--"
                    return (
                        <div>
                            {/* <div>账期:<span class="font-weight">{row.paymentDay}</span></div> */}
                            <div>Payment Term Name:{paymentName}</div>
                            <div>{this.$t("boss.purchase.settlement_remarks",{defaultValue:"结算备注"})}:<span class="font-weight">{row.paymentExplain}</span></div>
                        </div>
                    )
                }
            },
            {
                title: this.$t("boss.purchase.supplier_status",{defaultValue:"供应商状态"}),
                render:(h, { row })=>{
                    let status = '',
                        className = ''
                    switch(row.status){
                        case 'NORMAL': 
                        status = this.$t("boss.purchase.normal_cooperation",{defaultValue:"正常合作"});
                        className = 'tag-green tagSize'
                        break
                        case 'STOP': 
                        status = this.$t("boss.purchase.deactivate",{defaultValue:"停用"});
                        className = 'tag-red tagSize'
                        break
                        case 'CHECK': 
                        status = this.$t("boss.purchase.pending_approval",{defaultValue:"待审核"});
                        className = 'tag-blue tagSize'
                        break
                    }
                    return (
                        <div>
                            <span class={className}>{status}</span>
                        </div>
                    )
                }
            },
            {
                title: this.$t("boss.purchase.pending_approval",{defaultValue:"创建时间"}),
                key: 'created',
                sortable: true
            },
        ];
        },
        
    },

};
